import { PropsWithChildren, ReactNode } from "react";
import { useSurveyState } from "../SurveyContext";

export const Secure = ({ children, message = null }: PropsWithChildren<{ message: ReactNode }>) => {
  const { isAuthenticated } = useSurveyState();

  return <>{isAuthenticated ? children : message}</>;
};
